/**
 * GamesRoom.js
 * 
 * Displays available and upcoming games as cards.
 * - Responsive: 3 columns on large screens, stacked rows on smaller screens
 * - Uses the Card, CardHeader, CardTitle, and CardContent components from Card.js
 * - Button always sticks to the bottom, leaving equal top and bottom spacing
 */

import React from "react";
import Card, { CardHeader, CardTitle, CardContent } from "../components/ui/Card";
import Button from "../components/ui/Button";
import { useNavigate } from "react-router-dom";
import { games } from "../assets/Games/gamesWeHave";

const GamesRoom = () => {
    const navigate = useNavigate();

    /**
     * Navigates the user to the approapriate room
     * @param {Object} game     -   Game Information
     */
    const navigateToGame = (game) => {
        if (game.active && game.slug)
            navigate(`/${game.slug}`);
    }

    return (
        <div className="min-h-screen w-full flex flex-col items-center justify-start py-12 px-4 bg-black">
            {/* Page Title */}
            <h1 className="text-3xl font-bold mb-10 text-zinc-100 tracking-wide mt-20">
                Games Room
            </h1>

            {/* Grid of Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-6xl">
                {games.map((game, index) => (
                    <Card
                        key={index}
                        className={`h-36 flex flex-col justify-between transition-all hover:shadow-md hover:scale-[1.02] ${
                            game.active
                                ? "bg-white border-zinc-300 cursor-pointer"
                                : "bg-zinc-100 border-zinc-200 opacity-75 cursor-not-allowed"
                        }`}
                    >
                        {/* Card Header (Top) */}
                        <CardHeader>
                            <CardTitle className="text-xl font-semibold text-zinc-800">
                                {game.name}
                            </CardTitle>
                        </CardHeader>

                        {/* Card Content (Middle + Bottom Button) */}
                        <CardContent className="flex flex-col justify-between flex-1">
                            <p className="text-sm text-zinc-600 flex-grow mb-4">
                                {game.description}
                            </p>

                            {/* Button fixed at the bottom of the card */}
                            <div className="flex justify-center mt-auto">
                                <Button
                                    size="sm"
                                    className={`rounded-2xl w-32 ${
                                        game.active
                                            ? "bg-black text-white hover:bg-zinc-800"
                                            : "bg-zinc-300 text-zinc-600 cursor-not-allowed"
                                    }`}
                                    onClick={() => navigateToGame(game)}
                                >
                                    {game.status}
                                </Button>
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default GamesRoom;